import { render, staticRenderFns } from "./add-organisation.vue?vue&type=template&id=031ee19a&scoped=true"
import script from "./add-organisation.vue?vue&type=script&lang=js"
export * from "./add-organisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ee19a",
  null
  
)

export default component.exports